<template>
  <div class="sys-select">
    <div class="title">
      <div>{{ appList }}</div>
    </div>
    <div class="org-item" v-for="(item, index) in userInfo.appList" :key="item.orgId">
      <div class="item-header">
        <span>{{ userInfo.appList[index].orgNickName }}</span>
      </div>
      <div
        class="list-box"
        style="margin: 0"
        v-if="userInfo.appList[index].appInfoList[0].pType == 1"
      >
        <div v-for="(subItem, index) in item.appInfoList" :key="subItem.appId + index">
          <div
            class="list-item"
            :class="{ 'list-item-disable': subItem.status !== 0 }"
            @click="handleSelectApp(item, subItem)"
          >
            <div class="logo">
              <img :src="subItem.logo" alt="logo" />
              <div class="subItemName">{{ subItem.name }}</div>
              <div class="start-using"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="list-box1" v-else>
        <div v-for="(subItem, index) in item.appInfoList" :key="subItem.appId + index">
          <div
            class="list-item"
            :class="{ 'list-item-disable': subItem.status !== 0 }"
            @click="handleSelectApp(item, subItem)"
          >
            <div class="logo">
              <img :src="subItem.logo" alt="logo" />
              <div class="logo-box">
                <div class="subItemName">{{ subItem.name }}</div>
                <div class="start-using"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getPath from '../../../../utils/getPath.js';
import { mapGetters } from 'vuex';
import commonApi from 'api/common.js';
import store from 'utils/store.js';
import Vue from 'vue';

export default {
  computed: {
    ...mapGetters(['token', 'userInfo']),
    // TODO: 子系统排序
    appList() {
      this.userInfo.appList.forEach(item => {
        item.appInfoList.sort((a, b) => {
          return a.orderNum - b.orderNum;
        });
      });
    }
  },
  data() {
    return {
      // myHostName: ''
      orgId: '',
      tenantInfo: {
        tenantId: '',
        tenantName: ''
      },
      urlToken: ''
    };
  },

  created() {
    // 获取host，开发环境跳转子系统用
    // this.myHostName = window.location.hostname;
    this.$store.dispatch('getUserInfo');
  },
  methods: {
    // 跳转方法 appInfo: 当前选择的子系统
    handleJumpApp(appInfo, menuName, type = 1) {
      const { token, orgId, tenantInfo } = this;
      const { appType } = appInfo;
      const { account, pwd } = store.getSession('encParams') || {}; // 针对 全过程（外部）系统
      if (!account || !token || !orgId) {
        window.location.href = 'https://cgsmartpark.com:8091/#/login';
        return;
      }
      // 候选参数
      const candidate = { appInfo, token, orgId, account, pwd, tenantInfo, appType };
      appInfo.menuName = menuName;
      const path = getPath(appInfo, candidate);
      if (type === 2) {
        window.open(path, '_blank');
      } else {
        window.location.href = path;
      }
    },

    // 子系统选择
    handleSelectApp(item, subItem) {
      this.orgId = item.orgId;
      this.tenantInfo.tenantId = item.orgId;
      this.tenantInfo.tenantName = item.orgName;
      commonApi
        .getAppStatusTips({
          orgId: item.orgId,
          appId: subItem.appId,
          userId: this.userInfo.userId
        })
        .then(res => {
          const statusCode = res.data.code;
          if (statusCode === 200) {
            // if (subItem.pType === 5 && subItem.orderNum === 1) {
            //   window.location.href = subItem.address;
            //   return;
            // } else
              if (subItem.pType === 5 && subItem.orderNum === 3) {
              this.getUrl();
              // let token = window.localStorage.getItem('token')
              // token = token.replaceAll('"','')
              // window.open(`https://172.17.3.13:1443/portal/ui/index?thirdToken=${token}`, 'foo', 'noopener=yes,noreferrer=yes');

              return;
            }
            // console.log(subItem.name);
            // if (subItem.name === '生态环境监测系统') {
            //   // console.log(111);
            //   console.log(subItem.address);
            //   window.location.href = `${window.location.protocol}//${subItem.address}`;
            //   // this.handleJumpApp(subItem, '', 2);
            //   return;
            // }
            if (subItem.name === '数据可视化看板') {
              this.handleJumpApp(subItem, '', 2);
              return;
            }
               if (subItem.code === 'parking') {
              // console.log('parking');
              this.pathToPark();
              return;
            }

            if (
              item.orgNickName === '气象管理平台' ||
              item.orgNickName === '能源管控系统' ||
              item.orgNickName === '职业卫生管控系统'
            ) {
              this.handleJumpApp(subItem, subItem.name);
            } else {
              this.handleJumpApp(subItem);
            }
          } else if (statusCode === 20140010) {
            this.$message.error('账号认证失败，请联系管理员！');
          } else if (statusCode === 20140011) {
            this.$message.error('该系统正在开发中，敬请期待！');
          } else if (statusCode === 20140012) {
            this.$message.error('该系统已过试用期，请联系管理员续期！');
          } else if (statusCode === 20140013) {
            this.$message.error('当前账号尚未认证该系统，请联系管理员！');
          } else if (statusCode === 20140014) {
            this.$message.error('该系统已被冻结，请联系管理员！');
          } else if (statusCode === 20140015) {
            this.$message.error('该系统状态异常，请联系管理员！');
          } else {
            this.$message.error(res.data.message);
          }
        });
      // if (item.status !== 0) {
      //   this.$message.error('该系统正在开发中，敬请期待！');
      //   return;
      // }
      // // console.log(process.env.NODE_ENV);
      //
    },
    async getUrl() {
      await Vue.axios
        .get('/api/roses-closure/hikEventsController/getHikToken', {
          params: {
            orgName: 'admin'
          }
        })
        .then(res => {
          this.urlToken = res.data.data;
          window.open(
            `https://172.17.3.13:1443/bic/ssoService/v1/tokenLogin?token=${this.urlToken}&service=https://172.17.3.13:1443/portal/`,
            'foo',
            'noopener=yes,noreferrer=yes'
          );
        });
    },
      async pathToPark() {
      // let data = {};
      // if (process.env.NODE_ENV === 'development') {
       let data = {
          username: 'admin',
          password: 'admin123'
        };
      // } else {
      //   data = {
      //     username: atob(accsa),
      //     password: atob(accsb)
      //   };
      // }

      let res = await Vue.axios.post('/getLogin/admin-api/system/auth/login', data, {
        headers: {
          'tenant-id': 1
        }
      });
      let obj = {
        accessToken: res.data.data.accessToken,
        refreshToken: res.data.data.refreshToken
      };
      if (process.env.NODE_ENV === 'development') {
        window.open(
          `http://localhost/index?accessToken=${obj.accessToken}&refreshToken=${obj.refreshToken}`,
          'foo',
          'noopener=yes,noreferrer=yes'
        );
      } else {
        window.open(
          `https://cgwhpark.com:31702/index?accessToken=${obj.accessToken}&refreshToken=${obj.refreshToken}`,
          'foo',
          'noopener=yes,noreferrer=yes'
        );
      }
    }

  }
};
</script>

<style lang="less" scoped>
.sys-select {
  position: relative;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 24px 116px;
  span {
    padding-left: 16px;
    background: url('~assets/images/3817.png') no-repeat;
    background-position: left center;
  }
  .org-item {
    margin-bottom: 28px;
    .item-header {
      font-size: 20px;
      color: #0a1834;
      padding-left: 16px;
      font-weight: 700;
      margin-bottom: 18px;
    }

    .list-box {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-around;
      height: 100%;
      box-sizing: border-box;
      padding-bottom: 0;
      border-top: none;

      .list-item {
        box-sizing: border-box;
        position: relative;
        width: 240px;
        height: 270px;
        margin: 0px 38px 0px 0px;
        padding: 20px 16px;
        background: url('~assets/images/8320.png') no-repeat;
        opacity: 1;
        border-radius: 10px;
        cursor: pointer;

        // .triangle {
        //   position: absolute;
        //   top: 0;
        //   right: 0;
        //   width: 0;
        //   height: 0;
        //   border-top: 22px solid transparent;
        //   border-right: 22px solid transparent;
        //   border-bottom: 22px solid transparent;
        //   border-left: 22px solid transparent;
        //   border-radius: 0 10px 0 0;

        //   .el-icon-check {
        //     color: #fff;
        //     position: absolute;
        //     top: -16px;
        //     right: -16px;
        //   }
        // }

        .logo {
          text-align: center;
          img {
            // display: block;
            width: 120px;
            height: 120px;
            vertical-align: middle;
            margin-bottom: 10px;
            // border: 1px dashed #999;
          }
          .subItemName {
            font-size: 18px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 10px;
          }
          .start-using {
            margin-left: 34px;
            height: 48px;
            background: url('~assets/images/8396.png') no-repeat;
          }
        }
      }

      .list-item-disable {
        background: #f3f6fe;
        cursor: not-allowed;

        // .triangle {
        //   display: none;
        // }

        .logo {
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: gray;
          color: #c0c4ce;
        }
      }

      .list-item:hover {
        transform: scale(1.1);
        .start-using {
          background: url('~assets/images/8395.png') no-repeat;
        }
      }

      // .list-item:hover .triangle {
      //   transition: all 0.8s;
      //   border-top: 22px solid #409dff;
      //   border-right: 22px solid #409dff;
      // }
    }
  }

  /* .org-wrapper {
    position: relative;
    margin: 16px 16px 32px;
    border: 1px solid #ddd;
    border-radius: 2px;

    .org-title {
      display: inline-block;
      position: absolute;
      top: -16px;
      left: 16px;
      padding: 0 16px;
      height: 32px;
      line-height: 32px;
      background-color: #fff;
      color: #aaa;
      font-size: 14px;
    }

  } */
  .title {
    width: 100%;
    height: 200px;
    background: url('~assets/images/8327.png') no-repeat;
    background-position: 50% 10%;
    // margin-bottom: 40px;
    // margin-top: 16px;
  }
}
.list-box1 {
  display: flex;
  flex-wrap: wrap;
  // min-height: 312px;
  margin-top: 10px;
  padding: 30px 0 40px 48px;
  background: url('~assets/images/icon-bg.png') no-repeat;
  background-size: 100% 100%;
  .list-item {
    margin-right: 16px;
  }
  .logo {
    display: flex;
    align-items: center;
    padding: 8px 0px;
    img {
      width: 74px;
      height: 74px;
      margin-right: 8px;
    }
    .logo-box {
      width: 150px;
      .subItemName {
        font-weight: 600;
      }
      .start-using {
        margin-top: 6px;
        min-width: 88px;
        height: 32px;
        margin-left: -5px;
        background: url('~assets/images/8398 (1).png') no-repeat;
        cursor: pointer;
      }
      .start-using:hover {
        background: url('~assets/images/8398 (2).png') no-repeat;
      }
    }
  }
}
</style>
